import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { TrustRow } from './TrustRow';
import { Countdown } from './Countdown';
import { closeRows } from '../data/tables';
import { CHECKOUT_URL } from '../config/launch';
export function Close() {
  return <section aria-labelledby="close-heading" className="w-full bg-forest text-white" data-id="element-55" data-mp="1q01dqad433q7">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-28" data-id="element-56" data-mp="1kzwyennxwf1k">
        <div className="mx-auto max-w-3xl text-center" data-id="element-57" data-mp="1l1zwzw35rghw">
          <h2 id="close-heading" className="font-serif text-[27px] font-semibold leading-[1.15] text-white sm:text-4xl sm:leading-[1.12] lg:text-[46px]" data-id="element-58" data-mp="1g8n8dlyhb9p5">
            You teach non-harm at the top of every class. This is what it looks like as preparation.
          </h2>

          <p className="mt-6 font-sans text-[17px] leading-[1.65] text-white/70 sm:text-lg" data-id="element-59" data-mp="128cj2ncti363">
            Good intentions matter. On their own they're not a plan. This system doesn't ask you to
            be certain about anyone's body — no one can be. It asks you to be ready: with a calm
            response, a clear boundary, and a better option than the one you're currently
            improvising.
          </p>

          <p className="mt-8 font-sans text-[12px] font-semibold uppercase tracking-[0.14em] text-brass" data-id="element-60" data-mp="3lf4khjviy2m8">
            The protocol · The posture family map · The scripts · Thirty conditions · Nine
            populations · Scope and referral — all handled
          </p>
        </div>

        <ul className="mx-auto mt-10 max-w-3xl divide-y divide-white/10 border-y border-white/10 sm:mt-12" data-id="element-61" data-mp="mz3eba628m3g">
          {closeRows.map(([before, after]) => <li key={before} className="grid grid-cols-1 items-center gap-3 py-5 sm:grid-cols-[1fr_auto_1fr] sm:gap-4 sm:py-4" data-id="element-62" data-mp="d0w91ol4vsha">
              <div className="sm:text-right" data-id="element-63" data-mp="2suwktoalzf8x">
                <p className="font-sans text-[10px] font-semibold uppercase tracking-[0.14em] text-white/45 sm:hidden" data-id="element-64" data-mp="2xspooaofvx61">
                  Without
                </p>
                <span className="mt-1 block font-sans text-[15px] text-white/60 line-through sm:mt-0" data-id="element-65" data-mp="za31jjcppqoo">
                  {before}
                </span>
              </div>
              <ArrowRightIcon className="hidden h-4 w-4 text-brass sm:block" strokeWidth={2} aria-hidden="true" data-id="element-66" data-mp="uh1hyy1k92yr" />
              <div data-id="element-67" data-mp="kmhzlsrkpxic">
                <p className="font-sans text-[10px] font-semibold uppercase tracking-[0.14em] text-brass sm:hidden" data-id="element-68" data-mp="kiu3qmynoz0g">
                  With the system
                </p>
                <span className="mt-1 block font-sans text-[15px] font-semibold text-white sm:mt-0" data-id="element-69" data-mp="bl1qdochw1fp">
                  {after}
                </span>
              </div>
            </li>)}
        </ul>

        <div className="mt-12 text-center" data-id="element-70" data-mp="25xrl28aoteo5">
          <p className="font-sans text-[15px] text-white/70" data-id="element-71" data-mp="20zg9nt4quw3t">
            Screen &amp; Adapt™ Yoga Edition — 6 Volumes + 5 Bonuses ·{' '}
            <span className="line-through text-white/55" data-id="element-72" data-mp="28hxxl4ddadgb">$97</span>{' '}
            <span className="font-semibold text-brass" data-id="element-73" data-mp="2dhai3igrn8fq">→ $27</span>
          </p>

          <div className="mt-8" data-id="element-74" data-mp="2i8irwfm0cvtf">
            <Countdown size="sm" data-id="element-75" data-mp="2i9k4wpml3sds" />
          </div>

          <div className="mt-10 flex flex-col items-center" data-id="element-76" data-mp="2iavamuzlba7j">
            <CtaButton href={CHECKOUT_URL} size="xl" variant="brass-edge" data-id="element-77" data-mp="2n6anbjlv302d">
              Yes, I want Screen &amp; Adapt™
            </CtaButton>
            <TrustRow tone="dark" className="mt-6 justify-center" data-id="element-78" data-mp="1uiya401lc4lq" />
          </div>
        </div>
      </div>
    </section>;
}